<nav ngbNav #navOutgoingForm="ngbNav" class="nav-tabs" (navChange)="navChanged($event)">
  <ng-container ngbNavItem>
    <a ngbNavLink>Main Document</a>
    <ng-template ngbNavContent>
      <div *ngIf="doc">
        <br />
        <a [href]="'/documents/' + doc!.id + '/download'"><i class="fas fa-file-pdf-o"></i>&nbsp;{{ doc!.name }}</a>
        <br /><br />
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <input type="number" min="0" [(ngModel)]="outgoingTransaction.copies" class="form-control" placeholder="Copies number" aria-label="Copies number" />
              <div class="input-group-append"><span class="input-group-text">Copies</span></div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="custom-control custom-checkbox" (click)="toggleIncludeProof()">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="outgoingTransaction.include_proof" />
            <label class="custom-control-label">Include Proof</label>
          </div>
          <div class="custom-control custom-checkbox" (click)="outgoingTransaction.include_file_copy = !outgoingTransaction.include_file_copy">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="outgoingTransaction.include_file_copy" />
            <label class="custom-control-label">Include file copy</label>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem *ngIf="doc!.attachments_included">
    <a ngbNavLink>Attachments</a>
    <ng-template ngbNavContent>
      <div class="mx-1 my-3">
        <app-outgoing-form-dialog-attachments (attachmentsSelected)="attachmentsChanged($event)" [attachments]="attachments" [matter_id]="doc!.matter_id"></app-outgoing-form-dialog-attachments>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem>
    <a ngbNavLink>Recipients</a>
    <ng-template ngbNavContent>
      <div class="card border border-primary m-3">
        <div class="card-header text-white bg-primary">To - {{ documentToContacts.length }}</div>
        <ul class="list-group list-group-flush" style="font-size: 90%">
          <li class="list-group-item" *ngFor="let documentToContact of documentToContacts">
            <strong>{{ documentToContact.copy_of_contact }}</strong> {{ documentToContact.copy_of_address }}
            <div class="row">
              <div class="col-1">
                <label>Sent via:</label>
              </div>
              <div class="col-2">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentToContact.send_by_mail" class="form-check-input" type="checkbox" />
                    Mail
                  </label>
                </div>
                <label class="bg-light w-100 mx-1 p-1" *ngIf="documentToContact.send_by_mail">{{ documentToContact.mail_type }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentToContact.send_by_email" class="form-check-input" type="checkbox" />
                    Email
                  </label>
                </div>
                <label class="bg-light w-100 mx-1 p-1" *ngIf="documentToContact.send_by_email">{{ documentToContact.copy_of_email_address }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentToContact.send_by_fax" class="form-check-input" type="checkbox" />
                    Fax
                  </label>
                </div>
                <label class="bg-light w-100 p-1" *ngIf="documentToContact.send_by_fax">{{ documentToContact.copy_of_fax }}</label>
              </div>
              <div class="col-3">
                <div class="form-check" *ngIf="outgoingTransaction.include_proof">
                  <label class="form-check-label">
                    <input [(ngModel)]="documentToContact.include_proof" class="form-check-input" type="checkbox" />
                    Include Proof
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="card border border-success m-3">
        <div class="card-header text-white bg-success">CC - {{ documentCcContacts.length }}</div>
        <ul class="list-group list-group-flush" style="font-size: 90%">
          <li class="list-group-item" *ngFor="let documentCcContact of documentCcContacts">
            <strong>{{ documentCcContact.copy_of_contact }}</strong> {{ documentCcContact.copy_of_address }}
            <div class="row">
              <div class="col-1">
                <label>Sent via:</label>
              </div>
              <div class="col-2">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentCcContact.send_by_mail" class="form-check-input" type="checkbox" />
                    Mail
                  </label>
                </div>
                <label class="bg-light w-100 mx-1 p-1" *ngIf="documentCcContact.send_by_mail">{{ documentCcContact.mail_type }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentCcContact.send_by_email" class="form-check-input" type="checkbox" />
                    Email
                  </label>
                </div>
                <label class="bg-light w-100 mx-1 p-1" *ngIf="documentCcContact.send_by_email">{{ documentCcContact.copy_of_email_address }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentCcContact.send_by_fax" class="form-check-input" type="checkbox" />
                    Fax
                  </label>
                </div>
                <label class="bg-light w-100 p-1" *ngIf="documentCcContact.send_by_fax">{{ documentCcContact.copy_of_fax }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentCcContact.send_attachments" class="form-check-input" type="checkbox" />
                    Send Attachments
                  </label>
                </div>
                <div class="form-check" *ngIf="outgoingTransaction.include_proof">
                  <label class="form-check-label">
                    <input [(ngModel)]="documentCcContact.include_proof" class="form-check-input" type="checkbox" />
                    Include Proof
                  </label>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="doc!.attachments_included && documentCcContact.send_attachments">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="documentCcContact.show_attachments_edit = !documentCcContact.show_attachments_edit">
                      <i class="fas" [ngClass]="{ 'fa-plus-circle': !documentCcContact.show_attachments_edit, 'fa-minus-circle': documentCcContact.show_attachments_edit }"></i>
                      Select attachments for recipient
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12" *ngIf="documentCcContact.show_attachments_edit" style="padding-left: 20px">
                    <ul class="display-inline">
                      <li class="display-inline-block" *ngFor="let attachment of attachments">
                        <div class="form-group mb-0">
                          <a class="btn btn-link" target="_blank" [href]="'/documents/' + attachment.id + '/download?disposition=inline'">
                            <span *ngIf="attachment.name.length > 20">{{ attachment.name | slice: 0:14 }}...</span>
                            <span *ngIf="attachment.name.length <= 20">{{ attachment.name }}</span>
                          </a>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="documentCcContact.attachments[attachment.id]" />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="card border border-secondary m-3">
        <div class="card-header bg-secondary text-white">BCC - {{ documentBccContacts.length }}</div>
        <ul class="list-group list-group-flush" style="font-size: 90%">
          <li class="list-group-item" *ngFor="let documentBccContact of documentBccContacts">
            <strong>{{ documentBccContact.copy_of_contact }}</strong> {{ documentBccContact.copy_of_address }}
            <div class="row">
              <div class="col-1">
                <label>Sent via:</label>
              </div>
              <div class="col-2">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentBccContact.send_by_mail" class="form-check-input" type="checkbox" />
                    Mail
                  </label>
                </div>
                <label class="bg-light w-100 mx-1 p-1" *ngIf="documentBccContact.send_by_mail">{{ documentBccContact.mail_type }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentBccContact.send_by_email" class="form-check-input" type="checkbox" />
                    Email
                  </label>
                </div>
                <label class="bg-light w-100 mx-1 p-1" *ngIf="documentBccContact.send_by_email">{{ documentBccContact.copy_of_email_address }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentBccContact.send_by_fax" class="form-check-input" type="checkbox" />
                    Fax
                  </label>
                </div>
                <label class="bg-light w-100 p-1" *ngIf="documentBccContact.send_by_fax">{{ documentBccContact.copy_of_fax }}</label>
              </div>
              <div class="col-3">
                <div class="form-check disabled">
                  <label class="form-check-label">
                    <input [disabled]="true" type="checkbox" [(ngModel)]="documentBccContact.send_attachments" class="form-check-input" type="checkbox" />
                    Send Attachments
                  </label>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="doc!.attachments_included && documentBccContact.send_attachments">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="documentBccContact.show_attachments_edit = !documentBccContact.show_attachments_edit">
                      <i class="fas" [ngClass]="{ 'fa-plus-circle': !documentBccContact.show_attachments_edit, 'fa-minus-circle': documentBccContact.show_attachments_edit }"></i>
                      Select attachments for recipient
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12" *ngIf="documentBccContact.show_attachments_edit" style="padding-left: 20px">
                    <ul class="display-inline">
                      <li class="display-inline-block" *ngFor="let attachment of attachments">
                        <div class="form-group mb-0">
                          <a class="btn btn-link" target="_blank" [href]="'/documents/' + attachment.id + '/download?disposition=inline'">
                            <span *ngIf="attachment.name.length > 20">{{ attachment.name | slice: 0:14 }}...</span>
                            <span *ngIf="attachment.name.length <= 20">{{ attachment.name }}</span>
                          </a>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="documentBccContact.attachments[attachment.id]" />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem>
    <a ngbNavLink>Instructions</a>
    <ng-template ngbNavContent>
      <div class="mx-1 mb-1 mt-2">
        <div class="form-group">
          <label>Special Instructions</label>
          <textarea class="form-control" [(ngModel)]="outgoingTransaction.special_instructions"></textarea>
        </div>
        <div class="form-group">
          <label>Message to email recipients</label>
          <textarea class="form-control" [(ngModel)]="outgoingJob.message"></textarea>
        </div>
        <div class="form-check">
          <div class="custom-control custom-checkbox" (click)="outgoingJob.priority = !outgoingJob.priority">
            <input type="checkbox" [(ngModel)]="outgoingJob.priority" class="custom-control-input" />
            <label class="custom-control-label">High Priority</label>
          </div>
        </div>
        <div class="form-check" [ngClass]="{ 'mb-0': outgoingTransaction.wait_for_attachments }">
          <div class="custom-control custom-checkbox" (click)="outgoingTransaction.wait_for_attachments = !outgoingTransaction.wait_for_attachments">
            <input type="checkbox" [(ngModel)]="outgoingTransaction.wait_for_attachments" class="custom-control-input" />
            <label class="custom-control-label">Wait for attachments</label>
          </div>
        </div>
        <div class="form-group" *ngIf="outgoingTransaction.wait_for_attachments">
          <label>Describe</label>
          <textarea class="form-control" [(ngModel)]="outgoingTransaction.describe"></textarea>
        </div>
        <div class="form-check" [ngClass]="{ 'mb-0': outgoingTransaction.needs_check }">
          <div class="custom-control custom-checkbox" (click)="outgoingTransaction.needs_check = !outgoingTransaction.needs_check">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="outgoingTransaction.needs_check" />
            <label class="custom-control-label">Needs check</label>
          </div>
        </div>
        <div class="card" *ngIf="outgoingTransaction.needs_check">
          <div class="card-body">
            <h6 class="card-title">Check</h6>
            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label>Payee</label>
                  <app-contact-search (clearPayee)="clearPayee()" [include_item]="true" (contact)="onPayeeSelect($event)"></app-contact-search>
                </div>
                <div class="form-group">
                  <label>Amount</label>
                  <input type="number" [(ngModel)]="outgoingTransaction.check_amount" class="form-control" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem *ngIf="outgoingTransaction.include_proof">
    <a ngbNavLink>Proof</a>
    <ng-template ngbNavContent>
      <div class="row m-3 m-3">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="form-group" *ngIf="proofTemplates.length > 1">
                <label>Template</label>
                <select class="form-control" [(ngModel)]="selectedProofTemplateId">
                  <option *ngFor="let t of proofTemplates" [ngValue]="t.id">{{ t.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <button type="button" class="btn btn-outline-secondary" (click)="previewProof('document_proof_preview')">Preview</button>
              </div>
              <div class="form-group">
                <label>Proof date</label>
                <app-datepicker (date_result)="outgoingTransaction.proof_date = $event"></app-datepicker>
              </div>
              <div class="form-group">
                <label>Type served</label>
                <input type="text" class="form-control" [(ngModel)]="outgoingTransaction.type_served" />
              </div>
              <h5 class="my-3">Proof Recipients</h5>
              <ul class="list-group">
                <li class="list-group-item" *ngFor="let documentToContact of documentToContacts">
                  <div class="row">
                    <div class="col-1">To:&nbsp;</div>
                    <div class="col-11">
                      {{ documentToContact.copy_of_contact }}
                    </div>
                  </div>
                </li>
                <li class="list-group-item" *ngFor="let documentCcContact of documentCcContacts">
                  <div class="row">
                    <div class="col-1">CC:&nbsp;</div>
                    <div class="col-11">
                      {{ documentCcContact.copy_of_contact }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <h5 class="mb-1">Preview&nbsp;<small class="text-muted">Click preview to generate preview</small></h5>
              <div style="height: 30cm">
                <iframe frameborder="0" name="document_proof_preview" style="width: 100%; height: 100%"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem domId="summary">
    <a ngbNavLink>Summary</a>
    <ng-template ngbNavContent>
      <div class="m-3">
        <div class="row" *ngIf="!outgoingJobSummaryAllowed">
          <div class="col-12">
            <p class="text-danger">
              <strong>Errors:</strong>
            </p>
            <p class="text-danger" *ngIf="documentToContacts.length < 1">No &quot;To&quot; contacts have been selected</p>
            <p class="text-danger" *ngIf="doc!.attachments_included && attachments.length < 1">Include attachments has been checked but no attachments have been selected</p>
            <p class="text-danger" *ngIf="outgoingTransaction.include_proof && !outgoingTransaction.proof_date">Proof date has not been selected</p>
            <p class="text-danger" *ngIf="outgoingTransaction.include_proof && !outgoingTransaction.type_served">Type served has not been entered for proof</p>
            <p class="text-danger" *ngIf="outgoingTransaction.needs_check && !outgoingTransaction.check_payee_id">Payee has not been selected for check in Instructions</p>
            <p class="text-danger" *ngIf="outgoingTransaction.needs_check && !outgoingTransaction.check_amount">Check amount has not been filled in instructions</p>
            <p class="text-danger" *ngIf="outgoingTransaction.wait_for_attachments && !outgoingTransaction.describe">Wait for attachments has been checked but describe has not been filled under Instructions</p>
            <div *ngFor="let documentToContact of documentToContacts">
              <p class="text-danger" *ngIf="!documentToContact.send_by_mail && !documentToContact.send_by_email && !documentToContact.send_by_fax">
                <strong>To:&nbsp;</strong>
                {{ documentToContact.copy_of_contact }}
                &nbsp;does not have a delivery method checked
              </p>
            </div>
            <div *ngFor="let documentCcContact of documentCcContacts">
              <p class="text-danger" *ngIf="!documentCcContact.send_by_mail && !documentCcContact.send_by_email && !documentCcContact.send_by_fax">
                <strong>CC:&nbsp;</strong>
                {{ documentCcContact.copy_of_contact }}
                &nbsp;does not have a delivery method checked
              </p>
            </div>
            <div *ngFor="let documentBccContact of documentBccContacts">
              <p class="text-danger" *ngIf="!documentBccContact.send_by_mail && !documentBccContact.send_by_email && !documentBccContact.send_by_fax">
                <strong>BCC:&nbsp;</strong>
                {{ documentBccContact.copy_of_contact }}
                &nbsp;does not have a delivery method checked
              </p>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="outgoingJobSummaryAllowed">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-primary" (click)="createOutgoingJob(matterSummaryContentElement)" [disabled]="creatingOutgoingJob">
                  {{ creatingOutgoingJob ? 'Sending' : 'Send' }}<span *ngIf="creatingOutgoingJob">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                </button>
                &nbsp;
                <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="creatingOutgoingJob">Cancel</button>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-12">
                <div [innerHTML]="matterSummaryContent | safeHtml" #matterSummaryContentElement id="matter-summary-content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</nav>
<div [ngbNavOutlet]="navOutgoingForm"></div>
